import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a294b414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index gWidth animated animate__fadeIn" }
const _hoisted_2 = { class: "page-index_r" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_note = _resolveComponent("page-note")!
  const _component_cpn_synopsis = _resolveComponent("cpn-synopsis")!
  const _component_cpn_ranking = _resolveComponent("cpn-ranking")!
  const _component_cpn_introduce = _resolveComponent("cpn-introduce")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_note, { class: "" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_cpn_synopsis),
      _createVNode(_component_cpn_ranking, {
        isRequest: true,
        style: {"margin-top":"10px"}
      }),
      _createVNode(_component_cpn_introduce, { style: {"margin-top":"10px"} })
    ])
  ]))
}